import Vue from 'vue'
import moment from 'moment'
import axios from 'axios'

import App from './App.vue'
import vuetify from './plugins/vuetify'
import './plugins/apexcharts'

import './filters'
import router from './router'
import store from './store'

moment.locale('pt-br')

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers.Authorization = 'Bearer ' + localStorage.getItem('jwt')

Vue.config.productionTip = false

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
